import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

export default function AgentActivityDetail() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  const baseUrl =
    nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

  useEffect(() => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };

    axios
      .get(`${baseUrl}agent/activity/${id}`, { headers })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.error("Error fetching activity detail:", err);
      });
  }, [id]);

  if (!data)
    return (
      <div className="text-center mt-5">
        <h5>Loading activity data...</h5>
      </div>
    );

  const { allData, todayData, resetAt } = data;

  return (
    <div className="container mt-5">
      <h3 className="mb-3 text-uppercase">Agent/Admin Activity Details</h3>
      <p>
        <b>User ID:</b> {id}
      </p>
      {/* <p>
        <b>Last Reset:</b> {new Date(resetAt).toLocaleString()}
      </p> */}

      <div className="row mt-4">
        {/* ✅ All Data */}
        <div className="col-md-6">
          <div className="card p-3 shadow-sm">
            <h5 className="text-primary mb-3">All Time Data</h5>
            <ul className="list-group">
              <li className="list-group-item">
                Deposit: ₹{allData?.totalDeposit || 0}
              </li>
              <li className="list-group-item">
                Withdraw: ₹{allData?.totalWithdraw || 0}
              </li>
              <li className="list-group-item">
                Bonus: ₹{allData?.totalBonus || 0}
              </li>
              <li className="list-group-item">
                Penalty: ₹{allData?.totalPenalty || 0}
              </li>
            </ul>
          </div>
        </div>

        {/* ✅ Today Data */}
        <div className="col-md-6">
          <div className="card p-3 shadow-sm">
            <h5 className="text-success mb-3">Today's Data</h5>
            <ul className="list-group">
              <li className="list-group-item">
                Deposit: ₹{todayData?.todayDeposit || 0}
              </li>
              <li className="list-group-item">
                Withdraw: ₹{todayData?.todayWithdraw || 0}
              </li>
              <li className="list-group-item">
                Bonus: ₹{todayData?.todayBonus || 0}
              </li>
              <li className="list-group-item">
                Penalty: ₹{todayData?.todayPenalty || 0}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
